import { render, staticRenderFns } from "./clinic-details.vue?vue&type=template&id=202d9478&"
import script from "./clinic-details.vue?vue&type=script&lang=js&"
export * from "./clinic-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports